// Polyfills de métodos ES2022 pra navegador velho que ainda compra e vende
// aqui. Chrome 90/91 (POCOPHONE F1, moto g20 e afins) não tem
// Array.prototype.at, e alguma biblioteca do bundle chama isso: o app quebrava
// com "t.entries.at is not a function" — inclusive no LINK PÚBLICO, ou seja,
// cliente final tentando comprar (EletroModas e Ivar10, 27/07/2026).
//
// Vite/esbuild convertem SINTAXE pelo `target`, mas NÃO injetam polyfill de
// método — por isso mexer no target não resolvia.
//
// Este módulo é o PRIMEIRO import do main.tsx de propósito: import de módulo é
// avaliado antes do corpo de quem importa, então polyfill escrito dentro do
// main.tsx rodaria tarde demais pra dependência que usa o método no topo.
//
// Só métodos triviais e de semântica fechada. structuredClone e amigos ficam
// de fora: polyfill meia-boca é pior que a ausência.

function define(target: object, name: string, value: unknown): void {
  if (typeof (target as Record<string, unknown>)[name] === "function") return;
  Object.defineProperty(target, name, {
    value,
    writable: true,
    configurable: true,
    enumerable: false,
  });
}

// Array.prototype.at / String.prototype.at (Chrome 92)
function at(this: { length: number; [i: number]: unknown }, index: number): unknown {
  const len = this.length;
  const i = Math.trunc(index) || 0;
  const k = i < 0 ? len + i : i;
  return k < 0 || k >= len ? undefined : this[k];
}
define(Array.prototype, "at", at);
define(String.prototype, "at", function (this: string, index: number) {
  const r = at.call(Object(this) as never, index);
  return r === undefined ? undefined : String(r);
});

// Object.hasOwn (Chrome 93)
define(Object, "hasOwn", function (obj: object, prop: PropertyKey) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
});

// Array.prototype.findLast / findLastIndex (Chrome 97)
define(Array.prototype, "findLast", function (
  this: unknown[],
  predicate: (v: unknown, i: number, a: unknown[]) => boolean,
  thisArg?: unknown,
) {
  for (let i = this.length - 1; i >= 0; i--) {
    if (predicate.call(thisArg, this[i], i, this)) return this[i];
  }
  return undefined;
});
define(Array.prototype, "findLastIndex", function (
  this: unknown[],
  predicate: (v: unknown, i: number, a: unknown[]) => boolean,
  thisArg?: unknown,
) {
  for (let i = this.length - 1; i >= 0; i--) {
    if (predicate.call(thisArg, this[i], i, this)) return i;
  }
  return -1;
});
